import moment from 'moment';

/**
 * Standard date format: "23 Apr 2026"
 */
export const formatDate = (date: string | Date | null | undefined): string => {
  if (!date) return '';
  return moment(date).format('DD MMM YYYY');
};

/**
 * Date with time (no seconds): "23 Apr 2026 02:30 PM"
 * Use for general datetime fields
 */
export const formatDateTime = (date: string | Date | null | undefined): string => {
  if (!date) return '';
  return moment(date).format('DD MMM YYYY hh:mm A');
};

/**
 * Date with full time including seconds: "23 Apr 2026 02:30:45 PM"
 * Use for sensitive fields like createdAt, updatedAt, cancelledAt, paymentStatusLastUpdatedAt, etc.
 */
export const formatDateTimeWithSeconds = (date: string | Date | null | undefined): string => {
  if (!date) return '';
  return moment(date).format('DD MMM YYYY hh:mm:ss A');
};

/**
 * UTC date with full time including seconds (converts to IST +5:30): "23 Apr 2026 02:30:45 PM"
 * Use for UTC-stored sensitive fields like createdAt, updatedAt when UTC conversion is needed
 */
export const formatUTCDateTimeWithSeconds = (date: string | Date | null | undefined): string => {
  if (!date) return '';
  return moment.utc(date).add(5, 'hours').add(30, 'minutes').format('DD MMM YYYY hh:mm:ss A');
};
